// import "@/utils/windowOnError.js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { size: "medium", zIndex: 3000 });

// avue
import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";
Vue.use(Avue);

import _ from "lodash";
Vue.prototype._ = _;

// import Tiff from "tiff.js";

//富文本编辑器
import(/* webpackChunkName: "vue-quill-editor" */ "vue-quill-editor").then(
  VueQuillEditor => {
    Vue.use(VueQuillEditor);
  }
);
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

//代码编辑器
import VueCodeMirror from "vue-codemirror";
import "codemirror/lib/codemirror.css";
Vue.use(VueCodeMirror);

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("treeselect", Treeselect);

import HttpService from "./utils/httpService";
Vue.use(HttpService.install);
import Auth from "./directives/AuthButton.js";
Vue.use(Auth);

Vue.prototype.$axios = HttpService.Axios;
window.axios = HttpService.Axios;

Vue.config.productionTip = false;
//vue 初始化之前先根据登录状态拿权限数据
import { Loading } from "element-ui";
let token = sessionStorage.getItem("token");
if (token) {
  let loadingInstance = Loading.service({
    lock: true,
    text: "loading...",
    background: "rgba(225,225,225,0.2)",
    spinner: "el-icon-loading"
  });
  store.dispatch("layoutStore/getMenuData").then(res => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
    loadingInstance.close();
  });
} else {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}
